// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3yf04","error":"Textarea_error__3uFtg","readonly":"Textarea_readonly__Pq_dH","disabled":"Textarea_disabled__3kFIV"};